// test10
(10 && 0);
